import { GraphQLError } from "graphql";

import isApolloError from "./isApolloError";

const getApolloNonFieldErrors = (error: unknown): GraphQLError[] =>
  isApolloError(error)
    ? error.graphQLErrors.filter(({ errorInfo }) => !errorInfo?.path)
    : [];

export default getApolloNonFieldErrors;
